import { render, staticRenderFns } from "./ClassListAddNew.vue?vue&type=template&id=1dac8c56&"
import script from "./ClassListAddNew.vue?vue&type=script&lang=js&"
export * from "./ClassListAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports